export const TYPE = "task_type_cd";
export const CATEGORY = "task_category_cd";
export const DUE_DATE = "due_dt";
export const PRIORITY = "task_priority_cd";
export const STATUS = "task_status_cd";
